/**
 * Instance partagée du client API Victor.
 * - En dev : pointe sur /v1 (proxy Vite vers http://localhost:3000)
 * - En prod : VITE_API_BASE_URL (ex. https://api.myvictor.fr)
 *
 * Access token (JWT) en mémoire (pas localStorage, règle d'or n°6).
 * Refresh dans cookie httpOnly géré par l'API.
 */
import { createVictorApi } from "@victor/api-client";
import { demoFetch } from "./demo/demoFetch";
import { isDemoActive } from "./demo/demoMode";

let accessToken: string | null = null;
let onUnauthorizedHandler: (() => void) | null = null;

export function setAccessToken(token: string | null): void {
  accessToken = token;
}

export function getAccessToken(): string | null {
  return accessToken;
}

export function onUnauthorized(handler: () => void): void {
  onUnauthorizedHandler = handler;
}

const baseUrl = import.meta.env.VITE_API_BASE_URL ?? "";

export const api = createVictorApi({
  baseUrl,
  fetchFn: demoFetch,
  getAuthToken: () => accessToken,
  onUnauthorized: () => onUnauthorizedHandler?.(),
  onForbidden: (code) => {
    // En mode démo (exploration lecture seule), on n'éjecte jamais vers les
    // écrans d'onboarding réels : un 403 sur une requête réelle laissée passer
    // ne doit pas casser l'exploration.
    if (isDemoActive()) return;
    if (
      code === "tenant_suspended_payment" ||
      code === "tenant_suspended" ||
      code === "tenant_resilie"
    ) {
      // Pose le code pour la page dédiée + redirige hors React Router
      // pour éviter les fuites de queries en cours.
      sessionStorage.setItem("victor.blocked_code", code);
      if (window.location.pathname !== "/compte-bloque") {
        window.location.replace("/compte-bloque");
      }
    } else if (code === "contract_unsigned") {
      // Signature du contrat requise au 1er accès → écran de signature dédié.
      if (window.location.pathname !== "/signature") {
        window.location.replace("/signature");
      }
    }
  },
});
